import { format, isValid, parseISO } from 'date-fns';

/** `2026-09-01` (or a full ISO timestamp) → `September 1, 2026`; undefined when unparseable. */
export function formatDisplayDate(iso: string | undefined): string | undefined {
  if (!iso) return undefined;
  const parsed = parseISO(iso);
  return isValid(parsed) ? format(parsed, 'MMMM d, yyyy') : undefined;
}

/** Today as ISO `yyyy-MM-dd` (local) — the signing date sent to the API. */
export function todayISO(): string {
  return format(new Date(), 'yyyy-MM-dd');
}
